<template>
  <div
    class="myTitle-tem flex align-items justify-content-between"
    :class="{ 'text-2': type == 2 }"
  >
    <h3 class="flex align-items">
      <span class="icon rotate"></span>
      {{ title }}
      <!-- <dv-decoration-2 style="width: 100%; height:5px;" /> -->
    </h3>

    <span class="uuid">
      <slot name="uuid"> </slot>
    </span>
    <template v-if="right">
        <slot name="tab"> </slot>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    type: {
      type: [Number, String],
      default: 1,
    },
    right: {
      type: [Boolean, String],
      default: false,
    },
    uuid: {
      type: [Boolean, String],
      default: false,
    },
    isBg: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/comm.scss";
.myTitle-tem {
  width: 100%;
  height: 60px;
  font-weight: bold;
  color: #f0f0f0;
  background: url(~@/assets/images/myComm/title-3-1.png) left bottom no-repeat;
  background-size: 100%;
  > h3 {
    margin: auto 0;
    padding: 0 20px 0 70px;
    position: relative;
    white-space: nowrap;
    color: #fff;
    display: inline-block;
    font-size: 32px;
    @include ffamily-PMZD;
  }
  &.text-2 {
    background: url(~@/assets/images/myComm/title-3-2.png) left bottom no-repeat;
    background-size: 100% 54px;
    height: 75px;
    font-size: 30px;
    padding: 0 0 0 30px;
    @include ffamily-HT;
    padding-top: 10px;
    > h3 {
      // background: url(~@/assets/images/myComm/title-3-1.png) left bottom no-repeat;
      background-size: 100%;
      padding: 0 80px 0 0;
      font-size: 28px;
    }
  }
  .uuid {
    padding-right: 30px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 18px;
  }
}
.rotate {
  animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>